<ng-container *ngIf="form" [formGroup]="form">
    <div class="flex align-items-center gap-3">
        <p-selectButton [options]="options" (onOptionClick)="onOptionClick($event.option.value)" optionLabel="label" optionValue="value" [allowEmpty]="false"
           formControlName="option" ></p-selectButton>
        <span class="p-float-label">
            <p-dropdown [options]="dateOptions" [autoDisplayFirst]="false" placeholder="Data" optionLabel="label"
                optionValue="value" formControlName="date" (onChange)="addNewFilterEvent()"></p-dropdown>
            <label for="float-label" class="text-base">Data</label>
        </span>
    </div>
</ng-container>
